import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { WinnerPanel } from "@/components/auction/WinnerPanel";
import { CardPhoto, Label, money } from "@/components/auction/AuctionUI";
import { metaLine } from "@/components/AuctionCard";
import { ArrowLeft } from "lucide-react";
import { HitSectionLoading, useLoadingLevel } from "@/components/loading";

// Pantalla de pago del ganador / repechaje: destino del correo y del aviso al entrar.
export default function SubastaPagar() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [a, setA] = useState(null);
  const load = useCallback(() => {
    api.get(`/auctions/${id}`).then((r) => setA(r.data)).catch(() => navigate(`/subastas/${id}`, { replace: true }));
  }, [id, navigate]);
  useEffect(() => { load(); }, [load]);
  const level = useLoadingLevel(!a);

  if (!a || level !== "none") return <div className="max-w-xl mx-auto px-5 py-8 min-h-[70vh]"><HitSectionLoading level={level} loading={!a} section="auction" onRetry={load} /></div>;
  const o = a.my_offer;
  const payable = o && ["awaiting_payment", "repechage_offered"].includes(a.result);
  return (
    <div className="sx relative overflow-hidden" data-testid="auction-pay-page">
      <div className="sx-halo" />
      <div className="relative max-w-xl mx-auto px-5 pt-6 pb-16 space-y-4">
        <Link to={`/subastas/${a.id}`} className="inline-flex items-center gap-1.5 text-sm text-white/65 hover:text-white" data-testid="auction-pay-back">
          <ArrowLeft size={14} /> Ver la subasta
        </Link>
        <div className="sx-card p-4 flex items-center gap-4">
          <CardPhoto path={a.photos?.[0]} alt={a.product_name} w={64} h={88} size={300} rotate={0} glow="green" />
          <div className="min-w-0 flex-1">
            <div className="text-lg font-extrabold leading-tight" data-testid="auction-pay-title">{a.product_name}</div>
            <div className="text-xs text-white/55 mt-1">{metaLine(a)}</div>
          </div>
          {o && <div className="text-right"><Label>Tu puja</Label><div className="sx-price text-2xl text-[#34D399] mt-1">{money(o.amount)}</div></div>}
        </div>
        {payable ? <WinnerPanel a={a} onDone={load} /> : (
          <div className="sx-card p-6 text-center" data-testid="auction-pay-none">
            <p className="text-white/70 mb-4">No tienes un pago pendiente en esta subasta.</p>
            <Link to={`/subastas/${a.id}`} className="sx-btn inline-flex h-12 px-6 items-center">Ver la subasta</Link>
          </div>
        )}
      </div>
    </div>
  );
}
